import { getAssetDownloadURL } from '#pplx/frontend/apps/ask/queries/deeper-research-queries/getAssetDownloadURL.js';
import { isCodeInterpreterChartURL, isLocalFile, isUserGeneratedAsset, } from '#pplx/frontend/common/files/urls.js';
const MEDIA_DOWNLOAD_ASSET_TYPES = new Set([
    'AUDIO_FILE',
    'CHART',
    'GENERATED_IMAGE',
    'GENERATED_VIDEO',
    'SCREENSHOT',
]);
export function getMediaDownloadAssetType(assetType) {
    return MEDIA_DOWNLOAD_ASSET_TYPES.has(assetType)
        ? assetType
        : undefined;
}
export function shouldFetchArtifactDirectly(url, assetType) {
    return (getMediaDownloadAssetType(assetType) != null &&
        !isCodeInterpreterChartURL(url) &&
        !isLocalFile(url) &&
        !isUserGeneratedAsset(url));
}
async function fetchArtifactDownloadResponse({ url, filename, assetType, reason, signal, }) {
    const response = assetType != null && shouldFetchArtifactDirectly(url, assetType)
        ? await fetch(url, signal
            ? { mode: 'cors', cache: 'no-cache', signal }
            : { mode: 'cors', cache: 'no-cache' })
        : await getAssetDownloadURL({ request: { url, filename }, reason, signal }).then((downloadUrl) => (signal ? fetch(downloadUrl, { signal }) : fetch(downloadUrl)));
    if (!response.ok) {
        throw new Error(`Failed to fetch artifact: ${response.status}`);
    }
    return response;
}
export async function fetchArtifactDownloadBlob(request) {
    const response = await fetchArtifactDownloadResponse(request);
    return response.blob();
}
export async function fetchArtifactDownloadStreamedBlob({ signal, onBytesReceived, ...request }) {
    const response = await fetchArtifactDownloadResponse({ ...request, signal });
    if (!response.body)
        throw new Error('Artifact response body is unavailable');
    const reader = response.body.getReader();
    const chunks = [];
    try {
        while (true) {
            const { done, value } = await reader.read();
            if (done)
                break;
            onBytesReceived(value.byteLength);
            const chunk = new Uint8Array(value.byteLength);
            chunk.set(value);
            chunks.push(chunk);
        }
    }
    catch (error) {
        await reader.cancel().catch(() => undefined);
        throw error;
    }
    return new Blob(chunks, { type: response.headers.get('content-type') ?? '' });
}
//# sourceMappingURL=artifactDownload.js.map